import * as yup from 'yup';
import { DateTime } from 'luxon';

import { i18n } from 'i18n';
import { ForgotPasswordFormValues } from '../types';
import { DATE_FORMAT_PLACEHOLDER } from 'theSource/utils';

const startDate = DateTime.fromISO('1900-01-01T00:00:00.00');
const endDate = DateTime.fromISO('2100-01-01T00:00:00.00');

export const getValidationSchema = (): yup.SchemaOf<ForgotPasswordFormValues> =>
  yup.object({
    userName: yup.string().required(
      i18n.t('fieldCannotBeEmpty', {
        name: i18n.t('pages.forgotPassword:userName'),
        interpolation: { escapeValue: false },
      })
    ),
    lastName: yup.string().required(
      i18n.t('fieldCannotBeEmpty', {
        name: i18n.t('pages.forgotPassword:lastName'),
        interpolation: { escapeValue: false },
      })
    ),
    birthDate: yup
      .date()
      .transform((_, originalValue: DateTime | null) => {
        if (DateTime.isDateTime(originalValue)) {
          return originalValue.toJSDate();
        }
        return undefined;
      })
      .typeError(
        i18n.t('invalidDate', {
          format: DATE_FORMAT_PLACEHOLDER,
          interpolation: { escapeValue: false },
        })
      )
      .required(
        i18n.t('fieldCannotBeEmpty', {
          name: i18n.t('pages.forgotPassword:birthDate'),
          interpolation: { escapeValue: false },
        })
      )
      .max(
        endDate,
        i18n.t('invalidYear', {
          interpolation: { escapeValue: false },
        })
      )
      .min(
        startDate,
        i18n.t('invalidYear', {
          interpolation: { escapeValue: false },
        })
      ),
    lastFourDigitsOfSsn: yup.string().required(
      i18n.t('fieldCannotBeEmpty', {
        name: i18n.t('pages.forgotPassword:lastFourDigitsOfSsn'),
        interpolation: { escapeValue: false },
      })
    ),
  });
